exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-darker[data-v-2d1cdd9b] {\n    background-color: #e4e8eb;\n}\n", ""]);

// exports
